import React from 'react';

import {ButtonDanger, LinkInfo} from 'components/buttons';

import {Actions} from 'components/actions';

export const MailActions = (props) => (
  <Actions>
    <li>
      <ButtonDanger onClick={props.toggleModal} value="Видалити" />
    </li>
    <li>
      <LinkInfo to={`/admin/mailing/detail/${props.id}/edit`}>Редагувати</LinkInfo>
    </li>
  </Actions>
)



// WEBPACK FOOTER //
// ./src/admin/mailing/detail/mail-actions.js